export default __webpack_public_path__ + "static/media/cif-cg.68bede41.svg";